import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';


const initialState = {
    clubsList: null,
    currentClub: null,
    clubsListLoading: false
};

export const clubsAction = createAsyncThunk(
  'clubsAction',
  async (payload, { dispatch }) => {
    dispatch(setClubsListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/clubs';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setClubsListLoading(false))
                return data

            case 'post':
                ({ data } = await ax.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Клуб успешно отредактирован`
                })
                break;

            case 'put':
                ({ data } = await ax.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Клуб успешно добавлен`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Клуб успешно удален`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setClubsListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const getClubById = createAsyncThunk(
  'clubs/getById',
  async (payload, { rejectWithValue }) => {
      try {
          const { data } = await ax.get(`/api/admin/directory/clubs/${payload}`)
          return data
      } catch (error) {
          return rejectWithValue(`Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`)
      }
  }
)

export const getDecodedApiKey = createAsyncThunk(
  'clubs/getDecodedApiKey',
  async (payload, {rejectWithValue}) => {
      try {
          const { data } = await ax.post('/api/cryptography/Decode', payload)
          return data
      } catch (error) {
          return rejectWithValue(`Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`)
      }
  }
)

const ClubsSlice = createSlice({
    name: 'Clubs',
    initialState,
    reducers: {
        setClubsListLoading: (state, action) => {
            state.clubsListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(clubsAction.fulfilled, (state, action) => {
            state.clubsList = action.payload
        })
        builder.addCase(getClubById.fulfilled, (state, action) => {
            state.currentClub = action.payload
            state.clubsListLoading = false
        })
        builder.addCase(getClubById.rejected, (state, action) => {
            state.clubsListLoading = false
            openNotification({
                type: 'error',
                message: action.payload
            })
        })
        builder.addCase(getDecodedApiKey.fulfilled, (state, action) => {
            // ОТРЕДАКТИРОВАТЬ КУДА ИДЕТ ЗАПРОС
            state.currentClub.data.value.apiKey = action.payload.data.value
            
            state.clubsListLoading = false
        })
        builder.addCase(getDecodedApiKey.rejected, (state, action) => {
            state.clubsListLoading = false
            openNotification({
                type: 'error',
                message: action.payload
            })
        })
    }
});

export const { setClubsListLoading } = ClubsSlice.actions;

export default ClubsSlice.reducer